__turbopack_context__.v({
  "panel": "SimulatorHubTabPanel-module__mwsIdq__panel",
  "tabs": "SimulatorHubTabPanel-module__mwsIdq__tabs",
});
